import React from "react";
import { useLang } from "../context/LangContext";
import PageHeader from "../components/site/PageHeader";
import { INDUSTRIES, IMG } from "../lib/siteData";
import { tr } from "../lib/contentTranslations";
import { ArrowRight, Dot } from "lucide-react";
import { Link } from "react-router-dom";

const INDUSTRY_DETAILS = {
  water: ["Containerized RO/UF plants", "DAF and clarifier systems", "Dosing and chemical treatment", "Wastewater polishing skids", "Multimedia filtration"],
  oilgas: ["Onshore process and utility systems", "Pipelines and pumping stations", "Custody transfer metering skids", "Chemical injection skids", "Tank farms and auxiliary systems"],
  petro: ["Process & utility piping", "PLC and instrumentation packages", "MCC retrofits", "Hazardous-area lighting & equipment"],
  industrial: ["Mechanical bulk supply", "Electrical & I&C engineering", "Skid-mounted utility systems", "O&M and spare parts"],
  infra: ["Pumping stations", "Utility infrastructure", "Brownfield modifications", "Production-increase studies"],
};

const Industries = () => {
  const { t, lang } = useLang();
  return (
    <div data-testid="industries-page">
      <PageHeader eyebrow={t("nav.industries")} title={t("industries.title")} subtitle={t("industries.subtitle")} image={IMG.processPlant} />

      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 space-y-16">
          {INDUSTRIES.map((ind, idx) => {
            const details = INDUSTRY_DETAILS[ind.key] || [];
            const reverse = idx % 2 === 1;
            return (
              <div key={ind.key} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 items-stretch ${reverse ? "lg:[direction:rtl]" : ""}`} data-testid={`industry-${ind.key}`}>
                <div className="lg:col-span-7 [direction:ltr] relative">
                  <img src={ind.img} alt={ind.title} className="w-full h-72 lg:h-96 object-cover" />
                  <div className="absolute top-5 left-5 bg-brand text-white text-xs font-mono px-3 py-1.5 uppercase tracking-[0.2em]">{String(idx + 1).padStart(2, "0")}</div>
                </div>
                <div className="lg:col-span-5 [direction:ltr] flex flex-col justify-center">
                  <h2 className="font-heading font-extrabold text-3xl lg:text-4xl text-ink mb-4">{tr(lang, ind.title)}</h2>
                  <p className="text-ink-muted leading-relaxed mb-5">{tr(lang, ind.desc)}</p>
                  <ul className="space-y-2">
                    {details.map((d) => (
                      <li key={d} className="flex items-center gap-2 text-sm text-ink-soft">
                        <Dot className="w-5 h-5 text-brand -ml-1" /> {tr(lang, d)}
                      </li>
                    ))}
                  </ul>
                  <Link to="/rfq" className="inline-flex items-center gap-2 mt-6 text-brand font-semibold text-sm uppercase tracking-[0.18em] hover:gap-3 transition-all">
                    {t("common.requestQuote")} <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default Industries;
